
import { defineComponent } from 'vue'
import GoogleRatingLite from '~/components/widgets/GoogleRatingLite.vue'

export default defineComponent({
  components: {
    GoogleRatingLite,
  },
})
